import { getOptionName } from '../formUtils';
import { FormFieldComponentProps } from './fieldProps';

const CheckboxListField = ({ field, value, disabled, onChange, onBlur }: FormFieldComponentProps) => {
	const selectedIds = new Set(value ? value.split(',').filter(Boolean) : []);
	const isRowLayout = field.settings.optionsinrow === true;
	const allowedSelections = field.settings.allowedselections as number | undefined;

	const toggleOption = (optionId: string) => {
		const id = String(optionId);
		const newSelected = new Set(selectedIds);
		if (newSelected.has(id)) {
			newSelected.delete(id);
		} else {
			if (allowedSelections && newSelected.size >= allowedSelections) return;
			newSelected.add(id);
		}
		onChange(Array.from(newSelected).join(','));
	};

	return (
		<div onBlur={onBlur}>
			{field.label && <div className='biz-form-field__label'>{field.label}</div>}
			<div className={`biz-form-field__options ${isRowLayout ? 'biz-form-field__options--row' : ''}`}>
				{field.options.map((option) => {
					const name = getOptionName(option.translations);
					const optionId = String(option.id);
					const isChecked = selectedIds.has(optionId);
					const isDisabled = disabled || option.settings.disabled === true;

					return (
						<label
							key={optionId}
							className={`biz-form-field__option ${isChecked ? 'biz-form-field__option--selected' : ''}`}
						>
							<input
								type='checkbox'
								checked={isChecked}
								onChange={() => toggleOption(option.id)}
								disabled={isDisabled}
							/>
							<span className='biz-form-field__option-label'>{name}</span>
						</label>
					);
				})}
			</div>
		</div>
	);
};

export default CheckboxListField;
